const BoardsSortMethod = {
	ALPHABETICAL: 'alphabetical', // Alphabetical sorting by name
	UPDATED_AT: 'updated_at', // Sort by last updated date
	CUSTOM: 'custom', // Custom sorting order
} as const;

export default BoardsSortMethod;

export type BoardsSortMethodType = (typeof BoardsSortMethod)[keyof typeof BoardsSortMethod];